import React, { useEffect, useState } from "react"
import { useParams, useNavigate } from "react-router-dom"
import { Card, Button, Form, Row, Col } from "react-bootstrap"
import Select from "react-select"
import Layout from "../../../layout/default"
import clientService from "../services/clientService.js"
import mainSpecialtyService from "../../main_specialty/services/main_specialtyService"
import provinceService from "../../province/services/provinceService"

function ClientForm() {
  const { id } = useParams()
  const navigate = useNavigate()
  const [clientData, setClientData] = useState({
    name: "",
    last_name: "",
    email: "",
    phone_number: "",
    main_specialty: "",
    province: "",
    assignments_ids: [],
  })

  const [mainSpecialtyList, setMainSpecialtyList] = useState([])
  const [provinceList, setProvinceList] = useState([])
  const [lawyerList, setLawyerList] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true)
        const [specialties, provinces, lawyers] = await Promise.all([
          mainSpecialtyService.getMain_specialtyList(),
          provinceService.getProvinceList(),
          clientService.getLawyerList(),
        ])
        setMainSpecialtyList(specialties || [])
        setProvinceList(provinces || [])
        setLawyerList(lawyers || [])

        if (id) {
          const client = await clientService.getClientListDetails(id)
          setClientData({
            name: client.name || "",
            last_name: client.last_name || "",
            email: client.email || "",
            phone_number: client.phone_number || "",
            main_specialty: client.main_specialty || "",
            province: client.province || "",

            assignments_ids: client.assignments_detail
              ? client.assignments_detail.map((a) => a.lawyer_id)
              : [],
          })
        }
      } catch (error) {
        console.error("Error fetching client data:", error)
      } finally {
        setLoading(false)
      }
    }
    fetchData()
  }, [id])

  const handleChange = (e) => {
    const { name, value } = e.target
    setClientData((prev) => ({ ...prev, [name]: value }))
  }

  const handleLawyerSelectChange = (selectedOptions) => {
    const selectedValues = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : []
    setClientData((prev) => ({ ...prev, assignments_ids: selectedValues }))
  }

  const lawyerOptions = lawyerList.map((lawyer) => ({
    value: lawyer.id,
    label: `ID: ${lawyer.id} - ${lawyer.full_name || lawyer.name}`,
  }))

  const selectedLawyerOptions = lawyerOptions.filter((option) =>
    clientData.assignments_ids.includes(option.value)
  )

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      setLoading(true)
      if (id) {
        await clientService.updateClient(id, clientData)
      } else {
        await clientService.createClient(clientData)
      }
      navigate("/clients")
    } catch (error) {
      console.error("Error saving client:", error)
    } finally {
      setLoading(false)
    }
  }

  const pageTitle = id ? "Editar Cliente" : "Crear Cliente"
  const buttonLabel = id ? "Actualizar" : "Guardar"

  return (
    <Layout title={pageTitle} content="container" loading={loading}>
      <Card>
        <Card.Body>
          <h4 className="mb-4">{pageTitle}</h4>
          <Form onSubmit={handleSubmit}>
            <Row className="g-3">
              {/* Nombre */}
              <Col lg="6">
                <Form.Group>
                  <Form.Label>Nombre</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={clientData.name}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              {/* Apellidos */}
              <Col lg="6">
                <Form.Group>
                  <Form.Label>Apellidos</Form.Label>
                  <Form.Control
                    type="text"
                    name="last_name"
                    value={clientData.last_name}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              {/* Email */}
              <Col lg="6">
                <Form.Group>
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={clientData.email}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              {/* Teléfono */}
              <Col lg="6">
                <Form.Group>
                  <Form.Label>Teléfono</Form.Label>
                  <Form.Control
                    type="text"
                    name="phone_number"
                    value={clientData.phone_number}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              {/* Especialidad */}
              <Col lg="6">
                <Form.Group>
                  <Form.Label>Especialidad</Form.Label>
                  <Form.Select
                    name="main_specialty"
                    value={clientData.main_specialty}
                    onChange={handleChange}
                  >
                    <option value="">-- Selecciona --</option>
                    {mainSpecialtyList.map((sp) => (
                      <option key={sp.id} value={sp.id}>
                        {sp.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              {/* Provincia */}
              <Col lg="6">
                <Form.Group>
                  <Form.Label>Provincia</Form.Label>
                  <Form.Select
                    name="province"
                    value={clientData.province}
                    onChange={handleChange}
                  >
                    <option value="">-- Selecciona --</option>
                    {provinceList.map((prov) => (
                      <option key={prov.id} value={prov.id}>
                        {prov.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              {/* Asignación de Abogado(s) usando react-select */}
              <Col lg="12">
                <Form.Group>
                  <Form.Label>Asignar Abogado(s)</Form.Label>
                  <Select
                    isMulti
                    name="assignments_ids"
                    options={lawyerOptions}
                    value={selectedLawyerOptions}
                    onChange={handleLawyerSelectChange}
                    placeholder="Buscar abogado..."
                  />
                </Form.Group>
              </Col>
              <Col lg="12">
                <Button variant="primary" type="submit" disabled={loading}>
                  {loading ? "Guardando..." : buttonLabel}
                </Button>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>
    </Layout>
  )
}

export default ClientForm
